/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UnitsPage_allUnitMeasure$ref = any;
export type UnitsPagePaginationQueryVariables = {|
  count?: ?number,
  cursor?: ?string,
  code?: ?string,
|};
export type UnitsPagePaginationQueryResponse = {|
  +$fragmentRefs: UnitsPage_allUnitMeasure$ref
|};
export type UnitsPagePaginationQuery = {|
  variables: UnitsPagePaginationQueryVariables,
  response: UnitsPagePaginationQueryResponse,
|};
*/


/*
query UnitsPagePaginationQuery(
  $count: Int
  $cursor: String
  $code: String
) {
  ...UnitsPage_allUnitMeasure_Fr9TL
}

fragment UnitsPage_allUnitMeasure_Fr9TL on Query {
  allUnitMeasure(code: $code, first: $count, after: $cursor) {
    totalCount
    edges {
      node {
        id
        code
        description
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code",
    "type": "String"
  }
],
v1 = {
  "kind": "Variable",
  "name": "code",
  "variableName": "code"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnitsPagePaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          }
        ],
        "kind": "FragmentSpread",
        "name": "UnitsPage_allUnitMeasure"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnitsPagePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UnitMeasureNodeConnection",
        "kind": "LinkedField",
        "name": "allUnitMeasure",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitMeasureNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnitMeasureNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "code"
        ],
        "handle": "connection",
        "key": "Units_allUnitMeasure",
        "kind": "LinkedHandle",
        "name": "allUnitMeasure"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UnitsPagePaginationQuery",
    "operationKind": "query",
    "text": "query UnitsPagePaginationQuery(\n  $count: Int\n  $cursor: String\n  $code: String\n) {\n  ...UnitsPage_allUnitMeasure_Fr9TL\n}\n\nfragment UnitsPage_allUnitMeasure_Fr9TL on Query {\n  allUnitMeasure(code: $code, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        id\n        code\n        description\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0073d1c8b2fe722a463d4fce30fd20f0';

module.exports = node;
